<template>
  <div class="medical-record-wrapper">
    <div class="record-back" v-if="dataDone"></div>
    <div class="record-main" v-if="dataDone">
      <div class="record-header">
        <div class="header-card">
          <div class="base-info">
            <div class="info-box">
              <div class="avatar-info">
                <div class="avatar"><img :src="patientBaseInfo.avatar"></div>
                <div class="name">
                  <h4>{{patientBaseInfo.username}}</h4>
                  <p>{{patientBaseInfo.gender | genderFilter}}</p>
                </div>
              </div>
            </div>
            <div class="edit-userinfo" @click="editPersonalInfo"><icon icon-class="edit"></icon><span>个人资料</span></div>
          </div>
          <div class="patient-info">
            <div class="info-item">
              <div class="number">{{patientBaseInfo.birthday | ageFilter('number')}}</div>
              <div class="info-type">年龄</div>
            </div>
            <div class="info-item">
              <div class="number">{{parseFloat(patientBaseInfo.stature) || '-'}}</div>
              <div class="info-type">身高 (cm)</div>
            </div>
            <div class="info-item">
              <div class="number">{{parseFloat(patientBaseInfo.weight) || '-'}}</div>
              <div class="info-type">体重 (kg)</div>
            </div>
            <div class="info-item">
              <div class="number">{{patientBaseInfo.BMI || '-'}}</div>
              <div class="info-type">BMI</div>
            </div>
          </div>
          <div class="other-info-box">
            <div class="other-info" v-if="patientBaseInfo.allergy">
              <div class="type">过敏史</div>
              <div class="content">{{patientBaseInfo.allergy == '否认' ? '无过敏史' : patientBaseInfo.allergy == '不确定' ? '不确定过敏史' : patientBaseInfo.allergy}}</div>
            </div>
            <div class="other-info-more" v-show="openedInfo">
              <div class="other-info" v-if="patientBaseInfo.is_married != 3">
                <div class="type">婚况</div>
                <div class="content">{{patientBaseInfo.is_married | marriageFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.is_childbed != 3">
                <div class="type">是否生育</div>
                <div class="content">{{patientBaseInfo.is_childbed | whetherFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.nation">
                <div class="type">民族</div>
                <div class="content">{{patientBaseInfo.nation}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.job">
                <div class="type">职业</div>
                <div class="content">{{patientBaseInfo.job}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.is_smoke != 3">
                <div class="type">是否吸烟</div>
                <div class="content">{{patientBaseInfo.is_smoke | whetherFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.is_drink != 3">
                <div class="type">是否喝酒</div>
                <div class="content">{{patientBaseInfo.is_drink | whetherFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.gen_disease">
                <div class="type">家族遗传病史</div>
                <div class="content">{{patientBaseInfo.gen_disease}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.ser_disease">
                <div class="type">既往重大疾病史</div>
                <div class="content">{{patientBaseInfo.ser_disease}}</div>
              </div>
            </div>
          </div>
          <div class="toggle-arrow" :class="{'close': openedInfo}" @click="openedInfo = !openedInfo" v-if="showMoreInfo"><span>{{openedInfo ? '收起' : '展开全部'}}</span><icon icon-class="arrow"></icon></div>
        </div>
      </div>
      <div class="medical-record-wrapper">
        <div class="update-tips"><div class="tips-block"><icon icon-class="tips"></icon>为了医生更好地了解您的病情，请及时更新个人资料和病历</div></div>
        <h2>
          <span>归档病历</span>
          <button class="add-record" @click="addRecord"><icon icon-class="add"></icon>添加病历</button>
        </h2>
        <div class="record-list" v-if="records.length > 0">
          <div class="record-item-box" v-for="(item, index) in records" :key="index">
            <!-- 病历 -->
            <div class="record-item" v-if="item.type == 3">
              <div class="record-top">
                <div class="title">{{item.p_dep_title}} - {{item.dep_title}}</div>
                <div class="date">{{item.create_time | dateFilter}}</div>
              </div>
              <div class="record-content">
                <div class="content-item">
                  <div class="item-type">主诉</div>
                  <div class="item-content">{{item.self_reported}}</div>
                </div>
                <div class="content-item">
                  <div class="item-type">诊断</div>
                  <div class="item-content">{{item.diagnose}}</div>
                </div>
                <div class="content-item">
                  <div class="item-type">开方人</div>
                  <div class="item-content">{{item.doctor_username}} (医生)</div>
                </div>
              </div>
              <div class="unfinished" v-if="item.order_status == 1">
                <button class="finish-button pay" @click="toDetail(item)">去支付</button>
              </div>
              <div class="to-detail" v-else @click="toDetail(item)">
                <span>查看详情<icon icon-class="arrow"></icon></span>
              </div>
            </div>
            <!-- 问诊单 -->
            <div class="record-item" v-if="item.type == 2">
              <div class="record-top">
                <div class="title">问诊单 - {{item.p_dep_title}} - {{item.dep_title}}</div>
                <div class="date">{{item.create_time | dateFilter}}</div>
              </div>
              <div class="to-detail" v-if="item.status == 2" @click="toDetail(item)">
                <span>查看详情<icon icon-class="arrow"></icon></span>
              </div>
              <div class="unfinished" v-else>
                <button class="finish-button" @click="toDetail(item)">去填写</button>
              </div>
            </div>
            <!-- 首诊记录 -->
            <div class="record-item" v-if="item.type == 1">
              <div class="record-top">
                <div class="title">{{item.p_dep_title}} - {{item.dep_title}}<span>线下就诊</span></div>
                <div class="date">{{item.create_time | dateFilter}}</div>
              </div>
              <div class="to-detail" @click="toDetail(item)">
                <span>查看详情<icon icon-class="arrow"></icon></span>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-record" v-else>
          <icon icon-class="empty-template"></icon>
          <p class="text">暂无归档病历</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .medical-record-wrapper{
    position: relative;
    .record-back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: @xile;
      z-index: 1;
    }
    .record-main{
      position: relative;
      z-index: 10;
      padding-top: 16px;
      .record-header{
        padding: 0 16px;
        .header-card{
          position: relative;
          width: 100%;
          border-radius: 6px;
          box-shadow: 0px 4px 10px 0px rgba(0,132,138,0.08);
          background: #FFF;
          padding: 24px 16px 32px;
          .base-info{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .avatar-info{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .avatar{
                width: 48px;
                height: 48px;
                overflow: hidden;
                border-radius: 50%;
                flex-shrink: 0;
                img{
                  width: 100%;
                }
              }
              .name{
                color: @black;
                margin-left: 12px;
                h4{
                  margin-top: 4px;
                  font-size: 18px;
                  line-height: 18px;
                  font-weight: bold;
                }
                p{
                  margin-top: 8px;
                  font-size: 14px;
                  line-height: 14px;
                }
              }
            }
            .edit-userinfo{
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0 9px;
              font-size: 12px;
              line-height: 24px;
              color: #666;
              border: 1px solid #999;
              border-radius: 13px;

              span{
                position: relative;
                top: 1px;
                white-space: nowrap;
              }
              svg{
                font-size: 16px;
                line-height: 24px;
                margin-right: 4px;
              }
            }
          }
          .patient-info{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 24px 0 15px;
            border-bottom: 1px solid #EEE;
            color: @black;
            text-align: center;
            .info-item{
              .number{
                font-size: 18px;
                line-height: 23px;
              }
              .info-type{
                color: #666;
                margin-top: 12px;
                font-size: 14px;
                line-height: 14px;
              }
            }
          }
          .other-info-box{
            padding-top: 16px;
            .other-info-more{
              margin-top: 24px;
            }
            .other-info{
              margin-top: 24px;
              &:first-child{
                margin-top: 0;
              }
              .type{
                font-size: 14px;
                line-height: 14px;
                color: @black;
                font-weight: bold;
              }
              .content{
                margin-top: 8px;
                font-size: 14px;
                line-height: 20px;
                color: #666;
              }
            }
          }
          .toggle-arrow{
            position: absolute;
            bottom: 4px;
            left: 0;
            width: 100%;
            height: 24px;
            font-size: 12px;
            color: #999;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
              margin-right: 4px;
            }
            svg{
              transform: rotate(90deg) translateX(-1px);
            }
            &.close{
              svg{
                transform: rotate(-90deg) translateX(-2px);
              }
            }
          }
        }
      }
      .medical-record-wrapper{
        width: 100%;
        background: #FFF;
        .update-tips{
          margin-top: 12px;
          padding: 0 12px;
          .tips-block{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 7px 12px;
            background: rgba(245,164,30,0.05);
            border-radius: 2px;
            color: #F5A41E;
            font-size: 12px;
            line-height: 18px;
            svg{
              position: relative;
              top: 3px;
              flex-shrink: 0;
              margin-right: 6px;
              font-size: 12px;
              line-height: 18px;
              color: #F5A41E;
            }
          }
        }
        h2{
          margin-top: 20px;
          line-height: 20px;
          padding: 0 20px 12px;
          font-size: 18px;
          color: @black;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .add-record{
            width: 96px;
            height: 28px;
            line-height: 28px;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            font-size: 14px;
            border: 1px solid @xile;
            color: @xile;
            border-radius: 14px;
            background: #FFF;
            font-weight: normal;
            transition: all .2s;
            &:active{
              opacity: .8;
            }
            svg{
              width: 10px;
              color: @xile;
              margin-right: 5px;
            }
          }
        }
        .record-list{
          width: 100%;
          .record-item{
            border-top: 6px solid #F7F7F7;
            padding: 0 20px;
            .record-top{
              padding: 20px 0 12px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              border-bottom: 1px solid #EEE;
              .title{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 15px;
                line-height: 20px;
                font-weight: bold;
                color: @black;
                span{
                  position: relative;
                  top: -1px;
                  height: 20px;
                  border: 1px solid #999;
                  border-radius: 13px;
                  line-height: 20px;
                  font-size: 12px;
                  color: #666;
                  padding: 0 8px;
                  margin-left: 8px;
                  font-weight: normal;
                }
              }
              .date{
                margin-top: 6px;
                font-size: 15px;
                line-height: 15px;
                color: #999;
              }
            }
            .record-content{
              .content-item{
                margin-top: 20px;
                font-size: 14px;
                line-height: 14px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .item-type{
                  position: relative;
                  color: #666;
                  width: 55px;
                  flex-shrink: 0;
                  text-align-last: justify;
                }
                .item-content{
                  margin-left: 25px;
                  color: @black;
                  word-break: break-all;
                }
              }
            }
            .to-detail{
              display: flex;
              justify-content: flex-end;
              align-items: center;
              height: 46px;
              span{
                font-size: 14px;
                line-height: 14px;
                color: #666;
                display: flex;
                align-items: center;
                svg{
                  font-size: 12px;
                  color: #666;
                }
              }
            }
            .unfinished{
              padding: 16px 0;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .finish-button{
                @button-base();
                width: 72px;
                height: 32px;
                background: #F5A41E;
                font-size: 12px;
                &.pay{
                  background: #F96B6F;
                }
              }
            }
          }
        }
        .empty-record{
          border-top: 6px solid #F7F7F7;
          padding-top: 32px;
          text-align: center;
          font-size: 15px;
          line-height: 15px;
          svg{
            position: relative;
            left: -3px;
            font-size: 72px;
          }
          .text{
            margin-top: 12px;
            font-size: 15px;
            line-height: 15px;
            color: #CCC;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        showMoreInfo: false,
        openedInfo: false,
        patientBaseInfo: {},
        records: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      this.$root.post('/getPatientCase', {
        pat_id: this.userInfo.user_id,
        type: 1
      }).then(data => {
           console.log('getPatientCase');
        console.log(data);
        if(data.base_info.is_married != 3 || data.base_info.is_childbed != 3 || data.base_info.is_drink != 3 || data.base_info.is_smoke != 3 || data.base_info.ser_disease || data.base_info.job || data.base_info.nation) {
          this.showMoreInfo = true;
        }
        this.patientBaseInfo = data.base_info;

        if(parseFloat(this.patientBaseInfo.stature) && parseFloat(this.patientBaseInfo.weight)) {
          let heightM = parseFloat(this.patientBaseInfo.stature) / 100;
          this.patientBaseInfo.BMI = (parseFloat(this.patientBaseInfo.weight) / (heightM * heightM)).toFixed(1);
        }else {
          this.patientBaseInfo.BMI = '-'
        }
        this.records = data.info;
        this.dataDone = true;
      })
    },
    methods: {
      toDetail(item) {
        console.log(item);
        switch(parseInt(item.type)) {
          case 1: {
            // 跳转首诊记录页面
            // 已完成的首诊记录
            this.$router.push({path: '/patient/record/detail', query: {type: item.type, id: item.id}});
            // if(item.is_finish == 1) {
            //   // 未完成的首诊记录
            //   this.$router.push({path: '/patient/record/detail', query: {type: item.type, id: item.id, status: item.is_finish, doc_id: item.doc_id, create_time: item.create_time}});
            // }else {
            //   this.$router.push({path: '/patient/record/detail', query: {type: item.type, id: item.id, status: item.is_finish}});
            // }

          };break;
          case 2: {
            // 跳转问诊单详情
            if(item.status == 1) {
              // 未完成的问诊单
              // 判断医生类型跳转不同的问诊单
              if(item.answer_type == 1) {
                this.$router.push({path: '/patient/questionnaire', query: {id: item.id}});
              }else {
                this.$router.push({path: '/patient/questionnaire/westen', query: {id: item.id}});
              }
            }else if(item.status == 2) {
              // 已完成的问诊单
              this.$router.push({path: '/patient/record/detail', query: {type: item.type, id: item.id}});
            }

          };break;
          case 3: {
            // 跳转病历详情
            this.$router.push({path: '/patient/record/detail', query: {type: item.type, id: item.prescription_id, status: 1}});
          };break;
        }
      },
      // 编辑个人资料
      editPersonalInfo() {
        this.$router.push('/patient/info/edit');
      },
      // 添加病历
      addRecord() {
        this.$router.push('/patient/record/add');
      }
    },
    filters: {
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD');
      },
      whetherFilter(value) {
        switch(parseInt(value)) {
          case 1: return '是';break;
          case 2: return '否';break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MedicalRecord/index.vue